import React from 'react';
import { NuvemShop as NuvemShopIcon } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';

import { EHeadingSize, EHeadingWeight } from '@domain/enums/components/EHeading';
import CredentialOption from './CredentialOption';
import GatewayOption from './GatewayOption';
import SyncOption from './SyncOption';

import * as S from './styles';

const NuvemShopConfig: React.FC = () => {
  const theme: any = useTheme();

  const [selectedTab, setSelectedTab] = React.useState<number>(1);

  const onChangeTab = React.useCallback(index => setSelectedTab(index), []);

  return (
    <S.ContentWrapper>
      <S.Header>
        <NuvemShopIcon size={52} color={theme.colors.gray[2]} />
        <S.Heading type={EHeadingSize.H4} fontWeight={EHeadingWeight.MEDIUM}>
          Integração com NuvemShop
        </S.Heading>
      </S.Header>

      <S.Tab defaultTab={selectedTab} onChangeTab={onChangeTab}>
        <S.Option>Geral</S.Option>
        <S.Option>Sincronização</S.Option>
        <S.Option>Gateway</S.Option>
      </S.Tab>

      {selectedTab === 0 && <CredentialOption />}

      {selectedTab === 1 && <SyncOption />}

      {selectedTab === 2 && <GatewayOption />}
    </S.ContentWrapper>
  );
};

export default NuvemShopConfig;
